import type { ScannerType } from '@/stores/rfidSessionStore'

export type ScannerSetupGuide = {
  type: ScannerType
  title: string
  blurb: string
  preferred: 'Bluetooth HID' | 'USB / dock'
  imageSrc: string
  steps: string[]
  tips: string[]
}

export const SCANNER_SETUP_GUIDES: Record<ScannerType, ScannerSetupGuide> = {
  RFD8500: {
    type: 'RFD8500',
    title: 'RFD8500',
    blurb: 'Handheld sled — Bluetooth or USB keyboard wedge.',
    preferred: 'Bluetooth HID',
    imageSrc: '/scanners/rfd8500.png',
    steps: [
      'Turn the RFD8500 on and make it discoverable (Bluetooth button / power-on window).',
      'In this computer’s Bluetooth settings, pair the RFD8500. It should show as a keyboard once it is in HID keyboard mode.',
      'If the OS pairs it only as a serial/SPP device, set HID Keyboard Emulation once with 123RFID (or Zebra’s staging barcode), then re-pair.',
      'USB alternative: cradle/cable the reader so the OS sees a keyboard.',
      'Back in RFID Operations, tap the RFD8500 card, then pull the trigger — the EPC should appear under Last tag.',
    ],
    tips: [
      'App connect does not reconfigure the sled; it only arms this browser tab to receive keyboard scans.',
      'Keep this tab focused while scanning.',
    ],
  },
  RFD40: {
    type: 'RFD40',
    title: 'RFD40',
    blurb: 'Compact sled — USB/dock or Bluetooth keyboard wedge.',
    preferred: 'USB / dock',
    imageSrc: '/scanners/rfd40.png',
    steps: [
      'Power on the RFD40 and attach it via USB/dock to this computer (or pair Bluetooth HID if your unit supports it).',
      'Confirm the OS treats it as a keyboard (HID). Native eConnex/SDK mode used by the Android app is not available in a regular browser.',
      'If needed, set HID keyboard output once with 123RFID / Zebra tools, then reconnect.',
      'Back in RFID Operations, tap the RFD40 card, then pull the trigger to verify Last tag.',
    ],
    tips: [
      'On Zebra Android handhelds, use the native RFID Operations mobile app for zero-config eConnex/BLE.',
      'Keep this browser tab focused while scanning.',
    ],
  },
}
